module.exports = __webpack_public_path__ + "img/StandardPutawayPage.dd903e39.png";